import React from 'react';
import PropTypes from 'prop-types';
import {PriceDetailsWrapper} from '../../PriceDetailsWrapper/PriceDetailsWrapper';
import {BOOKING_CONFIRMATION} from '../../../utils/edapUtils';

export class Receipt extends React.PureComponent {
    static propTypes = {
        priceDetails: PropTypes.shape({}),
        translations: PropTypes.shape({}),
    };

    render() {
        return (
            <div className="Receipt">
                <div className="confirmation-item">
                    <PriceDetailsWrapper
                        actionLocation={BOOKING_CONFIRMATION}
                        priceDetails={this.props.priceDetails}
                        translations={this.props.translations}
                    />
                </div>
            </div>
        );
    }
}
